import { useUnits } from './Units';
import { Button } from 'components/common/Button';
import { Trans } from '@lingui/macro';

export default function SizeUnitSwitcher() {
    const { units, setUnits } = useUnits();
    return (
        <div className="flex items-center text-xs">
            <Trans>Change units:</Trans>
            <Button
                variant="link"
                onClick={() => setUnits('cm')}
                disabled={units === 'cm'}
            >
                <Trans>metric (cm)</Trans>
            </Button>
            <span>/</span>
            <Button
                variant="link"
                onClick={() => setUnits('in')}
                disabled={units === 'in'}
            >
                <Trans>US (inch)</Trans>
            </Button>
        </div>
    );
}
